import React from 'react'
import { Table } from 'antd'
import { Typography } from 'antd'

const { Text } = Typography

const CategoryDetailsTable = ({ categories, confidenceLevels }) => {
    const columns = [
        {
            title: '',
            dataIndex: 'categoryName',
            key: 'categoryName',
            width: 250,
            render: (text) => <Text>{text}</Text>
        },
        ...confidenceLevels.map(level => ({
            title: '',
            dataIndex: level,
            key: level,
            align: 'center',
            width: 150,
            render: (value) => value === 'N/A' ? 'N/A' : `${value}%`
        }))
    ]

    const dataSource = categories.map(category => {
        const row = {
            key: category.categoryId,
            categoryName: category.categoryName,
        }

        // Add individual confidence levels
        category.confidenceData.forEach(confidence => {
            row[confidence.confidenceLevel] = confidence.percentage
        })

        return row
    })

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            size='small'
            bordered
            showHeader={false}
            scroll={{ x: true }}
        />
    )
}

export default CategoryDetailsTable

